import { inlineYoutube } from './inlineYoutube';

export function ytInit() {
  const loadScript = ()=> {
    if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  const init = () => {
    inlineYoutube();
  }
  
  if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
    loadScript();
    window.onYouTubePlayerAPIReady = () => {
      init();
    };
  } else {
    init();
  }
}